import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Affiliates from "@/components/Affiliates";
import { Link } from "react-router-dom";
import { ArrowLeft, Code2, ArrowRight } from "lucide-react";

export default function PartnersPage() {
  return (
    <div className="relative min-h-screen bg-zinc-950 text-zinc-100" data-testid="partners-page">
      <Header />
      <div className="px-4 md:px-10 pt-8 pb-2">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs tracking-widest uppercase text-zinc-300 hover:text-red-500 transition-colors"
          data-testid="partners-back-home"
        >
          <ArrowLeft className="w-3 h-3" /> Back to home
        </Link>
      </div>
      <Affiliates />

      {/* Widget promo — for band pages, blogs, streamers, and fan sites */}
      <section className="px-4 md:px-10 pb-12" data-testid="partners-widget-promo">
        <Link
          to="/widget"
          className="group block border-2 border-zinc-800 hover:border-red-600 bg-black transition-colors"
          data-testid="partners-widget-link"
        >
          <div className="p-5 md:p-8 flex items-center gap-5 md:gap-8 flex-wrap">
            <div className="w-14 h-14 md:w-16 md:h-16 border-2 border-red-600 flex items-center justify-center text-red-500 group-hover:bg-red-600 group-hover:text-black transition-colors shrink-0">
              <Code2 className="w-6 h-6 md:w-7 md:h-7" strokeWidth={2.2} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[10px] tracking-[0.35em] text-red-500 uppercase mb-1 font-display">
                //_FREE_FOR_ANYONE
              </div>
              <div className="font-display text-2xl md:text-3xl leading-tight tracking-tight text-zinc-50">
                DROP THE <span className="text-red-600">&quot;NOW SPINNING&quot;</span> WIDGET ON YOUR SITE.
              </div>
              <p className="mt-2 text-sm text-zinc-400 leading-snug max-w-2xl">
                Copy-paste iframe. Auto-updates every 15 seconds. Custom
                accent color. Perfect for band pages, Twitch overlays,
                blogs, and fan sites. No account, no script.
              </p>
            </div>
            <div className="inline-flex items-center gap-2 text-xs tracking-widest uppercase font-display text-zinc-100 group-hover:text-red-500 transition-colors shrink-0">
              GET THE CODE <ArrowRight className="w-4 h-4" />
            </div>
          </div>
        </Link>
      </section>

      <Footer />
    </div>
  );
}
